<footer id="footer" class="footer">
  <div class="footer__inner">
    <div>
      <a class="footer__brand" href="#home" (click)="$event.preventDefault(); sectionSelected.emit('home')">DySi</a>
      <p>{{ settings.description }}</p>
      <div class="footer__socials">
        @for (link of settings.socialLinks; track link.label) {
          <a [href]="link.url" [attr.aria-label]="link.label"><i [class]="link.icon"></i></a>
        }
      </div>
    </div>

    <div>
      <h3>Important Links</h3>
      @for (link of settings.importantLinks; track link.label) {
        <a [href]="link.url">{{ link.label }}</a>
      }
    </div>

    <div>
      <h3>Quick Navigation</h3>
      @for (link of menus; track link.id || link.sectionId) {
        <a href="#{{ link.sectionId }}" (click)="$event.preventDefault(); sectionSelected.emit(link.sectionId)">
          {{ link.title }}
        </a>
      }
    </div>

    <form class="newsletter">
      <h3>Newsletter</h3>
      <label>
        <span>Email address</span>
        <input type="email" placeholder="you@example.com" />
      </label>
      <button class="btn btn--primary" type="submit">Subscribe</button>
    </form>
  </div>
  <p class="copyright">{{ settings.copyright }}</p>
</footer>
